import React from 'react';
import { BaseEdge, getBezierPath, type EdgeProps } from '@xyflow/react';
import EdgeDslTooltip, { edgeDsl } from './EdgeDslTooltip';

/**
 * A structural edge the pipeline implies rather than something the user typed:
 * a Connector collecting its distributor, a checkpoint following the one before
 * it. It is READ-ONLY by construction — no delete affordance, and styleEdges
 * marks it non-selectable/non-focusable/non-deletable so neither the Delete key
 * nor a click can reach it.
 *
 * It exists purely so these edges can carry the same hover tooltip the editable
 * ones do: their `dsl` (`checkpoint:fan`, `hero → clip`) is exactly the wiring a
 * user cannot see anywhere else in the editor, because there is no field behind
 * it to open.
 */
const DerivedEdge: React.FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  style,
  data,
}) => {
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  return (
    <>
      <BaseEdge id={id} path={edgePath} markerEnd={markerEnd} style={style} interactionWidth={16} />
      <EdgeDslTooltip edgeId={id} path={edgePath} dsl={edgeDsl(data)} />
    </>
  );
};

export default DerivedEdge;
